import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import AssignmentIcon from "@mui/icons-material/Assignment";
import toast, { Toaster } from "react-hot-toast";
import * as services from "../../services/services";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import SearchIcon from "@mui/icons-material/Search";

const PetList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const keyword = searchText.toLowerCase();

  const filtered = rows.filter((p) =>
    p.petName.toLowerCase().includes(keyword) || p.petCode?.toLowerCase().includes(keyword) ||
  p.hospitalPetCode?.toLowerCase().includes(keyword)
  );

  const columns = [
    { field: "no", headerName: "No", flex: 0.5 },
    { field: "hospitalPetCode", headerName: "IDสัตว์เลี้ยง", flex: 1.5 },
    { field: "petId", headerName: "BOW ID", flex: 1 },
    { field: "petName", headerName: "ชื่อสัตว์เลี้ยง", flex: 2 },
    { field: "petType", headerName: "ชนิดสัตว์เลี้ยง", flex: 1 },
    { field: "Breed", headerName: "สายพันธุ์", flex: 2 },
    { field: "owner", headerName: "เจ้าของ", flex: 2 },
    {
      field: "detail",
      headerName: "รายละเอียด",
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // กึ่งกลางแนวนอน
            alignItems: "center", // กึ่งกลางแนวตั้ง
            width: "100%",
            height: "100%",
          }}
        >
          <AssignmentIcon
            style={{ color: "#1976d2", cursor: "pointer" }}
            onClick={() => {
              navigate(`/pets/${params.row.id}`, {
                state: params.row,
              });
            }}
          />
        </div>
      ),
    },
  ];
  const fetchHistory = useCallback(async () => {
    const res = await services.getPets();
    const rawData = res.data.data;

    const productsWithIndex = rawData.map((item, index) => ({
      ...item,
      no: index + 1,
      id: item.id,
      petId: item.petCode ??'-',
      hospitalPetCode: item.hospitalPetCode,
      petName: item.name,
      petType: item.type,
      Breed: item.breed,
      owner:
        item.owner === null
          ? "ไม่มีเจ้าของ"
          : item.owner.firstName + " " + item.owner.lastName,
    }));

    setRows(productsWithIndex);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 2,
          my: 2,
        }}
      >
        {/* ส่วนซ้าย: หัวข้อ + Search */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography component="h2" variant="h5" sx={{ whiteSpace: "nowrap" }}>
            รายการสัตว์เลี้ยง
          </Typography>
          <TextField
            fullWidth
            label="ค้นหา"
            placeholder="ชื่อสัตว์ / Pet ID"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ maxWidth: { xs: "100%", sm: 420 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/pets/create")}
          sx={{ whiteSpace: "nowrap", height: 40 }}
        >
          เพิ่มสัตว์เลี้ยง
        </Button>
      </Box>

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid rows={filtered} columns={columns} loading={loading} />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default PetList;
